module.exports = "/_next/static/media/2406354510e3285f1a2ec4dbd00677e1.png";